import React, { useState } from 'react';
import { Modal, Popover } from 'antd';

import { ColpromiseResponse } from 'services/collection';
import moment from 'moment';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { toCurrency } from 'utils/utils';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { isNil } from 'lodash';

type ColPromiseListModalProps = {
  data: ColpromiseResponse[];
  visible: boolean;
  onClose: () => void;
  type: 'PROM' | 'COMM';
};

const ColPromiseListModal = (props: ColPromiseListModalProps) => {
  const { data, onClose, visible, type } = props;

  const [open, setOpen] = useState<boolean[]>([]);

  const handleOpenChange = (index: number, open: boolean) => {
    setOpen((prevOpen) => {
      prevOpen[index] = open;
      return [...prevOpen];
    });
  };
  const columns: DataGridColDef<any>[] = [
    {
      dataIndex: 'promtypelabel',
      key: 'promtypelabel',
      width: '8%',
    },
    {
      dataIndex: type === 'COMM' ? 'promcreationdate' : 'promdate',
      key: type === 'COMM' ? 'promcreationdate' : 'promdate',
      width: '10%',
      render: (val) => (!isNil(val) ? moment(val).format('YYYY-MM-DD') : null),
    },
    {
      dataIndex: 'promamount',
      key: 'promamount',
      width: '10%',
      render: (value, record) =>
        toCurrency(value, localStorage.getItem('currcode') ?? ''),
    },
    {
      dataIndex: type !== 'COMM' ? 'cireference' : '',
      key: type !== 'COMM' ? 'cireference' : '',
      width: type !== 'COMM' ? '15%' : 'hide',

      // render: (value, record) => (
      //   <ModalControllerNV
      //     content={({ setVisible, visible }) => (
      //       <a onClick={() => setVisible(true)}>{record.cireference}</a>
      //     )}
      //     modal={({ setVisible, visible }) => (
      //       <CIDetail
      //         ciid={Number(record.ciid)}
      //         onCancel={() => setVisible(false)}
      //         showAsModal
      //         visible={visible}
      //         isCreateCI={false}
      //         showButtons={false}
      //       />
      //     )}
      //   />
      // ),

      render: (_, record) => {
        var regex = /RENT\d+/g;
        var codesArray = record?.promcomment?.match(regex);

        if (codesArray && codesArray?.length === 1) {
          return codesArray[0];
        } else if (codesArray && codesArray?.length > 1) {
          return 'Multiple';
        } else {
          return '';
        }
      },
    },
    {
      dataIndex: 'username',
      key: 'username',
      width: '15%',
    },

    {
      dataIndex: 'promcomment',
      key: 'promcomment',
      render: (val, index) => {
        let array = String(val ?? '')
          ?.replace(/\n+/g, '\n')
          ?.split('\n');
        var regex = /RENT\d+/g;
        var codesArray = val?.match(regex);
        return (
            <Popover
              content={<p style={{ width: '400px' }}>{val}</p>}
              placement="topRight"
              trigger="click"
              open={open[index]}
              onOpenChange={(open) => handleOpenChange(index, open)}
            >
              {array?.map((line, i) => (
                <span key={i} style={{ cursor: 'pointer' }}>
                  {line} <br />
                </span>
              ))}
            </Popover>
          
        );
      },
      width: '30%',
      ellipsis: true,
    },
  ];
  return (
    (<Modal
      title={
        <GetLabel
          label={type === 'COMM' ? 'ColCommentHistory' : 'ColPromiseHistory'}
        />
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={1000}
    >
      <DataGrid
        size="small"
        bordered
        dataSource={data ?? []}
        columns={
          type === 'COMM'
            ? columns.filter((col) => col.key !== 'promamount')
            : columns
        }
        scroll={{ x: 0, y: 350 }}
        pagination={{
          responsive: true,
          position: ['none' as any],
        }}
      />
    </Modal>)
  );
};

export default ColPromiseListModal;
